module.exports = __webpack_public_path__ + "img/icon-side-bar-9.5afb2bce.svg";